import React from 'react'
import { withTranslation } from "react-i18next";

const dummyImage = "https://images.letsway.com/live/tr:w-1080/https://storage.googleapis.com/kouto-api-media-live/2025/2/8558e3759d5c51e64d310119a4828598211edc1e767473bb.png";

const EventDetails = (props) => {
    const { t } = props;
    return (
        <div className='event-details-card'>
            <div className="container">
                <div className='event-img'>
                    <img src={dummyImage} alt={t("way_activity.event_details_page.image_alt")} />
                </div>
                <div className="text-container">
                    <div>
                    <p className='heading'>{props.heading}</p>
                    </div>
                    <div>
                        <p className='sub-heading'>{props.subheading}</p>
                    </div>
                    <div>
                        <p className='description'>{props.description}</p>
                    </div>
                    <div className="controls">
                        {/* <button className="button" onClick={() => { }}>Book an Activity</button> */}
                        {/* <button className="button secondary" onClick={() => { props.page(1) }}>back</button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation("translations")(EventDetails)